var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modal-wrapper",staticClass:"m-modal m-modal__screen-tint",class:_vm.classList},[_c('div',{ref:"wrapper",staticClass:"m-modal__position-wrapper",class:{
      'm-modal__position-wrapper_fullscreened': _vm.isFullscreened
    },on:{"click":_vm.handleOuter}},[_c('div',{ref:"container",staticClass:"m-modal__container"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }